(function($) {

  var pageId = "page-calendar-event-new",
    page = '#' + pageId;

  $(function() {
    $(document)
      .on("click", page + " .btn-save-event", saveEventClick)
      .on("change", page + ' #select-cal', function(e) {
        calChange();
      })
      .on("change", page + " #select-schedule-every", scheduleEveryChange)
      .on("click", page + " .link-cancel", function() {
        $('.link-page-behind:last').trigger('click');
      })
      .on('click', page + ' .cb-visitor-lock', function(e) {
        refreshManageMembers();
      })
      .on('ajax:beforeSend', page + ' form.form-event', function(e, xhr, settings) {
        var selectEl = $(this).find('#select-cal'),
          memberGuids = $(this).find(".member.selected").map(function() {
            return $(this).data('guid');
          }).get().join(",");

        if (selectEl.is(':disabled')) {
          settings.data += "&caleventable_guid=" + selectEl.find('option').val();
        }

        settings.data += "&member_guids=" + memberGuids;
      })
      .on('ajax:success', page + ' form.form-event', function(e, result) {
        var eventFilter = simple.util.storage.get('calEventFilter_' + tower.team.guid);
        var guid = result.calendar_events[0].caleventable_guid;

        if (eventFilter) {
          var guids = eventFilter.split(',');
          if ($.inArray(guid, guids) < 0) {
            guids.push(guid);
            simple.util.storage.set('calEventFilter_' + tower.team.guid, guids.join(','));
          }
        } else {
          simple.util.storage.set('calEventFilter_' + tower.team.guid, guid);
        }

        tower.stack.load(result.url, {
          replace: true
        });
      });
  });

  function refreshManageMembers() {
    var $page = $(page);
    var selectEl = $page.find(".manage-members");
    var opt = $page.find("#select-cal option:selected");
    var memberGuids = opt.data("member-guids") || [];

    var visitorLock = $page.find('.cb-visitor-lock').prop('checked');
    var members = tower.updateManageMembers(selectEl, memberGuids, visitorLock);
    $page.find('.cal-members-field').toggle(members.length > 0);
  }

  function calChange() {
    var $page = $(page);
    var selectEl = $page.find(".manage-members");
    var opt = $page.find("#select-cal option:selected");
    var input = $page.find("[name=caleventable_type]");
    var memberGuids = opt.data("member-guids") || [];

    var visitorLock = false;
    var $visitorLock = $page.find('.visitor-lock');
    var $cbVisitorLock = $visitorLock.find('.cb-visitor-lock');
    if (opt.is("[data-project]")) {
      input.val("Project");
      if (opt.is('[data-guest-lockable]')) {
        $visitorLock.show();
        visitorLock = $cbVisitorLock.prop('checked');
      } else {
        $visitorLock.hide();
        $cbVisitorLock.prop('checked', false);
      }
    } else {
      input.val("Calendar");
      $visitorLock.hide();
      $cbVisitorLock.prop('checked', false);
    }

    var members = tower.updateManageMembers(selectEl, memberGuids, visitorLock);
    $page.find('.cal-members-field').toggle(members.length > 0);
  }

  function scheduleEveryChange() {
    var $select = $('#select-schedule-every');
    var every = $select.val() * 1;
    var form = $select.closest('form');
    var untilWrap = form.find('.event-schedule-until');
    var untilDate = $endMoment.getMoment();
    var intervalWrap = form.find('.event-schedule-interval');
    var weekdaysWrap = form.find('.event-schedule-weekdays');

    if (every === 0) {
      untilWrap.removeClass('repeatable').addClass('hide');
      intervalWrap.addClass('hide');
      weekdaysWrap.addClass('hide');
      $select.css('width', 193);
    } else {
      untilWrap.addClass('repeatable').removeClass('hide');
      $select.css('width', 77);
      if (every === 1) {
        untilDate.add(5, 'year');
      } else if (every === 2) {
        untilDate.add(6, 'month');
      } else if (every === 3) {
        untilDate.add(6, 'month');
      } else if (every === 5) {
        untilDate.add(6, 'month');
        intervalWrap.removeClass('hide');
        weekdaysWrap.removeClass('hide');
      }
    }
    $untilMoment.setMoment(untilDate.format("YYYY-MM-DD"));
  }

  function saveEventClick(e) {
    e.preventDefault();
    var form = $(this).closest('.form'),
      txtContent = form.find("#txt-event-content"),
      content = $.trim(txtContent.val());

    form.find('#select-cal').trigger('change');
    if (!content) {
      txtContent.addClass("error");
      return false;
    } else {
      txtContent.removeClass("error");
    }

    form.trigger('submit');
    return false;
  }

  window.$startMoment = null;
  var $endMoment = null;
  var $untilMoment = null;

  $(document).on('pjaxload#' + pageId, function(e, $page, page) {
    $page.find("#txt-event-content")
      .on('keydown', function(e) {
        if (e.which == 13) {
          e.preventDefault();
          $page.find(".btn-save-event").trigger('click');
        }
      })
      .autosize()
      .focus();

  $page.find("#txt-event-desc").autosize();

    var notAllDayChecked = simple.util.storage.get('calendar-not-all-day-checked') == 'true'

    var $cb = $page.find('.cb-all-day').on('click', function(e) {
      var $cb = $(this);
      var checked = $cb.prop('checked');

      $page.find('.event-time').toggleClass('all-day', checked);
      simple.util.storage.set('calendar-not-all-day-checked', !checked);

      if ($startMoment) {
        $startMoment.destroy();
      }
      if ($endMoment) {
        $endMoment.destroy();
      }
      initMomentpicker(checked);
    }).trigger('click');

    if (notAllDayChecked) {
      $cb.trigger('click')
    }

    $untilMoment = simple.momentpicker({
      el: $('#until_moment'),
      displayFormat: 'YYYY/MM/DD',
      cls: 'until-momentpicker calendar-momentpicker'
    });

    if (window.calEventData) {
      var $form = $page.find('.form-event');

      $.each(window.calEventData, function(index, obj) {
        if (obj.name == 'starts_at') {
          $startMoment.setMoment(moment(obj.value, 'YYYY-MM-DDTHH:mm:ss'))
        } else if (obj.name == 'ends_at') {
          $endMoment.setMoment(moment(obj.value, 'YYYY-MM-DDTHH:mm:ss'))
        } else if (obj.name == 'schedule_every') {
          scheduleEveryChange()
        } else if (obj.name == 'cb-all-day' && !obj.value) {
          $form.find('.cb-all-day').prop('checked', false)
          $('#start_moment').addClass('point-in-time').removeClass('all-day')
          $('#end_moment').addClass('point-in-time').removeClass('all-day')
        } else {
          $form.find('[name=' + obj.name + ']').val(obj.value)
        }
      });
      window.calEventData = null;
    }

    tower.initManageMembers($page);

    calChange();
  });

  function initMomentpicker(checked) {
    var $start_input = $('#start_moment');
    var $end_input = $('#end_moment');
    var start_time = null;
    var end_time = null;
    if (checked) {
      start_time = $start_input.val() ? moment($start_input.val(), 'YYYY-MM-DDTHH:mm:ss') : moment()
      end_time = $end_input.val() ? moment($end_input.val(), 'YYYY-MM-DDTHH:mm:ss') : moment()
      $start_input.addClass('all-day').removeClass('point-in-time')
      $end_input.addClass('all-day').removeClass('point-in-time')
      start_time.hours(0)
      end_time.minute(0)
      end_time.seconds(0)
      end_time.hours(23)
      end_time.minute(59)
      end_time.seconds(59)
    } else {
      start_time = moment($start_input.val(), 'YYYY-MM-DDTHH:mm:ss')
      end_time = moment($end_input.val(), 'YYYY-MM-DDTHH:mm:ss')
      $start_input.addClass('point-in-time').removeClass('all-day')
      $end_input.addClass('point-in-time').removeClass('all-day')
      start_time.hours(9)
      end_time.hours(10)
      end_time.minute(0)
      end_time.seconds(0)
    }

    $startMoment = simple.momentpicker({
      el: $start_input,
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      cls: 'calendar-momentpicker'
    });

    $endMoment = simple.momentpicker({
      el: $end_input,
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      cls: 'calendar-momentpicker'
    });

    $startMoment.setMoment(start_time)
    $endMoment.setMoment(end_time)

    var handleTime = function(type) {
      var startTime = $startMoment.getMoment();
      var startTimeStamp = startTime.toDate().getTime();
      var endTimeStamp = $endMoment.getMoment().toDate().getTime();
      // 是否为全天日程
      var allDay = $('.cb-all-day').is(':checked');

      if (startTimeStamp >= endTimeStamp) {
        if (type === 'start') {
          if (allDay) {
            // 86399秒 == 23小时59分59秒
            $endMoment.setMoment($startMoment.getMoment().add(86399, 'seconds'));
          } else {
            $endMoment.setMoment($startMoment.getMoment().add(1, 'hours'));
          }
        } else {
          if (allDay) {
            $startMoment.setMoment($endMoment.getMoment().add(-86399, 'seconds'));
          } else {
            $startMoment.setMoment($endMoment.getMoment().add(-1, 'hours'));
          }
        }
      }
    };

    $startMoment.on('select', function(e, params) {
      handleTime('start');
    });

    $endMoment.on('select', function(e, params) {
      handleTime('end');
    });
  }

})(jQuery);
